module.exports = __webpack_public_path__ + "img/Logo-login.a30c4192.png";